<template>
<div id="footerWrap" :class="viewClass">
  <footer id="footer" class="footer" v-if="!isLinksMode">
  	<div id="ftSitemap" class="container"><div class="columns">
  			<div class="column menu">
  				<dl class="menu-list">
  					<dt class="menu-label"><span class="icon"><i class="fas fa-crown"></i></span><a href="https://yutai.jafnavi.jp/">会員優待情報</a></dt>
  					<dd><a href="https://yutai.jafnavi.jp/">会員優待施設を探す</a></dd>
  					<dd><a href="https://jaf.or.jp/common/app" target="_blank">JAFアプリ</a></dd>
  					<dd><a href="https://yutai.jafnavi.jp/search-result?newshop=1">新規優待施設</a></dd>
  					<dd><a href="https://jaf.or.jp/common/global-support/showcard" target="_blank">海外で使える会員優待サービス</a></dd>
  					<dd><a href="https://area.jaf.or.jp/membership/premium">JAFプレミアムサービス</a></dd>
  					<dd><a href="https://area.jaf.or.jp/membership/life-support">JAFライフサポート</a></dd>
  				</dl>
  				<dl class="menu-list">
  					<dt class="menu-label"><span class="icon"><i class="fas fa-book-open"></i></span>JAF Mate</dt>
  					<dd><a href="https://jaf.or.jp/individual/use-jaf-more/jafmate" target="_blank">冊子JAF Mate・JAF PLUS</a></dd>
  				</dl>
  			</div>
  			<div class="column menu">
  				<dl class="menu-list">
  					<dt class="menu-label"><span class="icon"><i class="fas fa-car"></i></span><a href="https://drive.jafnavi.jp/">ドライブ・イベント</a></dt>
  					<dd><a href="https://area.jaf.or.jp/drive/japan-drive">日本の魅力、再発見／ごきげんロードトリップ</a></dd>
  					<dd><a href="https://area.jaf.or.jp/drive/stamp-rally">ドライブスタンプラリー</a></dd>
  					<dd><a href="https://drive.jafnavi.jp/spots/">おでかけスポットを探す</a></dd>
  					<dd><a href="https://drive.jafnavi.jp/courses/">ドライブコースを探す</a></dd>
  					<dd><a href="https://drive.jafnavi.jp/events/">イベントを探す</a></dd>
  					<dd><a href="https://drive.jafnavi.jp/map/">地図から探す</a></dd>
  					<dd><a href="https://drive.jafnavi.jp/usefulnesses/">お役立ち情報</a></dd>
  					<dd><a href="https://drive.jafnavi.jp/manual/drivejafnavi_manual.pdf">ドライブ情報ページ操作マニュアル</a></dd>
  				</dl>
  			</div>
  			<div class="column menu">
  				<dl class="menu-list">
  					<dt class="menu-label"><span class="icon"><i class="fas fa-gift"></i></span><a href="https://jafnavi.jp/qs/search_present.php">プレゼント情報</a></dt>
  					<dd><a href="https://jafnavi.jp/qs/search_present.php">各地域発！プレゼント情報</a></dd>
  				</dl>
  			</div>
  			<div class="column menu">
  				<dl class="menu-list">
  					<dt class="menu-label"><span class="icon"><i class="fas fa-question"></i></span>サポート</dt>
  					<dd><a :href="jafnaviGuide">会員優待のご利用方法</a></dd>
  					<dd><a href="https://jaf.or.jp/individual/join-us" target="_blank" class="ga_event_btn_join" id="footer">入会・継続・各種手続き</a></dd>
  					<dd><a href="https://support.jaf.or.jp/?site_domain=default" target="_blank">よくあるご質問</a></dd>
  					<dd><a href="https://area.jaf.or.jp/guidance/sitemap">サイトマップ</a></dd>
  					<dd><a href="https://jaf.or.jp/corporate/partnership/member-benefits" target="_blank">会員優待サービスの提携をご検討の方へ</a></dd>
  				</dl>
  			</div>
  	</div></div>
  	<!--ftSitemap end-->
  	<nav id="foot" class="navbar" role="navigation" aria-label="footer navigation">
  		<div class="container x-navbar-menu">
  			<ul class="navbar-start">
  				<li class="navbar-item topc"><a href="https://jafnavi.jp/kiyaku.php">利用規約<i class="fas fa-chevron-right sp"></i></a></li>
  				<li class="navbar-item"><a href="https://jaf.or.jp/common/privacy" target="_blank">個人情報の取り扱いについて<i class="fas fa-chevron-right sp"></i></a></li>
  				<li class="navbar-item"><a href="https://jaf.or.jp/corporate/partnership/member-benefits" target="_blank">会員優待サービスの提携をご検討の方へ<i class="fas fa-chevron-right sp"></i></a></li>
  				<li class="navbar-item"><a href="https://jaf.or.jp/" target="_blank">JAFホームページ<i class="fas fa-chevron-right sp"></i></a></li>
  				<li class="navbar-item"><a class="ot-sdk-show-settings" style="cursor: pointer;"><i class="fas fa-chevron-right sp"></i></a></li>
  			</ul>
  			<div class="navbar-end">
  				<p class="navbar-item logo"><a href="https://jaf.or.jp/" target="_blank"><img src="/img/ft_tx001.gif" width="278" height="49" alt="一般社団法人日本自動車連盟" /></a></p>
  			</div>
  		</div>
  	</nav>
  	<!--ftPrivate end-->
  	<div id="ftBottom" class="level">
  		<div class="container x-copyright"><span class="pc">CopyRight</span> &copy; <abbr title="JAPAN AUTOMOBILE FEDERATION"><span class="txt_abbr">(JAF)</span></abbr>. All rights reserved.</div>
  	</div>
  </footer>
</div>
</template>
<script>
import * as link from '@utils/link'

export default {
  name: 'Footer',
  data() {
    return {
      view: window.innerWidth > 767 ? 'pc' : 'sp',
      jafYoyaku:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_YOYAKU
          : link.JAF_NAVI_YOYAKU_TEST,
      jafnaviGuide:
        process.env.NODE_ENV === 'production'
          ? link.JAF_NAVI_GUIDE
          : link.JAF_NAVI_GUIDE_TEST,
    }
  },
  computed: {
    isLinksMode() {
      if (this.$store.state.auth.userType == '80' && this.$store.state.auth.loggedIn) {
        return true
      }

      return false
    },
    viewClass() {
      if (this.view === 'pc') {
        return 'pc view_pc'
      } else {
        return 'sp view_sp'
      }
    },
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.footer {
  border-top: none;
  background: #eee;
  padding: 0;
  display: block;
  width: 100%;
  margin-top: 10px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1232px;
  min-width: 1022px;
  margin: 0 auto;
  padding: 0 12px;
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}

.container {
  padding: 0 12px;
}

#ftBottom {
  // background: #d80038;
//  background: white;
//  color: #0a0044;
  padding: 2em 0 3em;
}
#ftBottom .container {
    display: block;
    font-size: .9375em;
    box-sizing: border-box;
    text-align: center;
}
#ftBottom abbr {
    text-decoration: none;
}
#ftBottom abbr::before {
      content: attr(title);
}

@media screen and (max-width: 767px) {
  #ftBottom {
    text-align: center;
    padding: 1em 0 10px;
  }
  #ftBottom .container {
    max-width: 100%;
    min-width: 100%;
    padding: 0 0.667em;
  }
  #ftBottom .pc {
    display: none;
  }
}
</style>
